/* eslint-disable no-underscore-dangle */
import React, { useContext, useEffect, useState } from 'react';
import ReactMarkdown from 'react-markdown';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';

import { assignFormDesignToCSSVars } from '../fields-customise.style';
import { FormContext } from '../../../shared/contexts/form-context';
import { selectCtrlIdLabelMap } from '../../selectors';
import { ControlPropType } from '../../ctrl_proptype';
import {
  ValidationWarning,
  MainfieldWrapper,
  DescriptionField,
  SubtextWrapper,
  FieldWrapper,
  Field
} from '../../common-field-styles';

const Description = ({ ctrl, formDesign }) => {
  const [ctrlValidationError, setCtrlValidationError] = useState(ctrl._validationError ?? '');
  const ctrlIdLabelMap = useSelector(selectCtrlIdLabelMap);
  const fieldLabel = ctrlIdLabelMap?.[ctrl.internal_id];
  const { inBuilder } = useContext(FormContext);

  useEffect(() => {
    if (inBuilder) setCtrlValidationError(ctrl._validationError ?? '');
  }, [ctrl._validationError, inBuilder]);

  const markdownLabel = fieldLabel?.replaceAll('<b style="color: #5972ce">', '**')?.replaceAll('</b>', '**');

  return (
    <MainfieldWrapper style={assignFormDesignToCSSVars(inBuilder, formDesign)}>
      <FieldWrapper>
        {inBuilder && ctrlValidationError && (
          <ValidationWarning className="ui bottom pointing basic label red">{ctrlValidationError}</ValidationWarning>
        )}

        <Field>
          <DescriptionField notInBuilder={!inBuilder}>
            <ReactMarkdown children={markdownLabel} className="pre-wrap" linkTarget="_blank" />
          </DescriptionField>

          <SubtextWrapper id="descriptive text">{ctrl.props.subtext}</SubtextWrapper>
        </Field>
      </FieldWrapper>
    </MainfieldWrapper>
  );
};

Description.defaultProps = {
  formDesign: null,
};

Description.propTypes = {
  ctrl: PropTypes.shape(ControlPropType).isRequired,
  formDesign: PropTypes.shape({
    old: PropTypes.object.isRequired,
    design: PropTypes.object.isRequired,
  }),
};
export default Description;
